export const damageColors = ["crimson", "chocolate", "hotpink"] as const;
